<div style="display: flex; height: 100%;">
  <div style="display: flex; overflow: hidden; width: 100%;">
    <div style="display: flex; flex-direction: column; margin: 20px; z-index: 1; overflow: hidden; width: 100%;">
      <mat-toolbar color="primary"
        style="place-content: center space-between; align-items: center; flex-direction: row; box-sizing: border-box; display: flex; padding: 20px;"
        class="toolbar-over-card">
        <!-- Title -->
        <div>Uploads | Total Items: <span>{{totalEntries$ | async }}</span></div>

        <div style="display: flex; font-size: medium; align-items: center;">
          <button mat-button *inRole="[roles.Operations, roles.Administrator]" [disabled]="selectedUploadIds.length < 1"
            (click)="scheduleJobBatchValidation(selectedUploadIds)"
            matTooltip="This run upload batch validation on the selected upload batches.">
            <div class="fal fa-exclamation-circle" style="font-size: 18px; margin-right: 10px;"></div>
            <span>Validate</span>
          </button>
          <button *inRole="[roles.Administrator]" mat-button aria-label="DeNIST"
            (click)="scheduleJob('de-nist')" [disabled]="selectedUploadIds.length < 1"
            matTooltip="DeNIST all documents in selected uploads.">
            <div class="fal fa-layer-minus" style="font-size: 18px; margin-right: 10px;"></div>
            <span class="lex font body" data-font-size="80px">DeNIST (old)</span>
          </button>
			<button *inRole="[roles.Operations, roles.Administrator]" mat-button aria-label="DeNIST"
					(click)="requestDeNistForSelected()" [disabled]="selectedUploadIds.length < 1"
					matTooltip="DeNIST all documents in selected uploads.">
				<div class="fal fa-layer-minus" style="font-size: 18px; margin-right: 10px;"></div>
				<span class="lex font body" data-font-size="80px">DeNIST</span>
			</button>
          <button *inRole="[roles.DeleteDocFeatureSet, roles.Administrator]" mat-button aria-label="Delete Selected"
            (click)="deleteSelected()" [disabled]="selectedUploadIds.length < 1"
            matTooltip="Deletes the selected uploads and associated documents.">
            <div class="fal fa-trash" style="font-size: 18px; margin-right: 10px;"></div>
            <span>Delete</span>
          </button>
          <button *inRole="[roles.DeleteDocFeatureSet]" mat-button aria-label="Upload" (click)="startNewUpload()"
            style="padding-right: 10px;">
            <div class="fal fa-plus" style="font-size: 18px; margin-right: 10px;"></div>
            <span>New Upload</span>
          </button>
          <button mat-icon-button [disabled]="(hasPreviousPage$ | async) === false" (click)="loadPreviousPage()"
            style="margin-right: -8px;" matTooltip="Previous page">
            <mat-icon>chevron_left</mat-icon>
          </button>
          <button mat-icon-button [disabled]="(hasNextPage$ | async) === false" (click)="loadNextPage()"
            style="margin-right: -8px;" matTooltip="Next page">
            <mat-icon>chevron_right</mat-icon>
          </button>
          <button
            *inRole="[roles.DeleteDocFeatureSet, roles.Operations, roles.PowerUploadFeatureSet, roles.Administrator]"
            mat-icon-button [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button *inRole="[roles.PowerUploadFeatureSet, roles.Administrator]" mat-menu-item
              (click)="scheduleDeduplicateJob(false)"
              matTooltip="Marks the duplicate documents across the entire case.">
              <div class="fal fa-clone" style="font-size: 18px; margin-right: 20px;"></div>
              <span>DeDuplicate</span>
            </button>
            <button *inRole="[roles.PowerUploadFeatureSet, roles.Administrator]" mat-menu-item
              (click)="scheduleDeduplicateJob(true)"
              matTooltip="Marks the duplicate documents across the entire case by Custodian.">
              <div class="fal fa-clone" style="font-size: 18px; margin-right: 20px;"></div>
              <span>DeDuplicate by Custodian</span>
            </button>
            <button *inRole="[roles.Operations, roles.Administrator]" mat-menu-item
              (click)="scheduleJob('email-threading')"
              matTooltip="Identify all emails in the case that are part of the same email thread.">
              <div class="fal fa-list-tree" style="font-size: 18px; margin-right: 20px;"></div>
              <span>Email Threading</span>
            </button>
            <button *inRole="[roles.Operations, roles.Administrator]" mat-menu-item
              (click)="scheduleJob('identify-near-duplicates')"
              matTooltip="Marks similar documents across the entire case.">
              <div class="fal fa-clone" style="font-size: 18px; margin-right: 20px;"></div>
              <span>Identify Near Duplicates</span>
            </button>
            <button *inRole="[roles.PowerUploadFeatureSet, roles.Administrator]" mat-menu-item
              (click)="scheduleJob('assign-control-numbers')"
              matTooltip="This will assign a Control Number to each document in the case.">
              <div class="fal fa-arrow-down-1-9" style="font-size: 18px; margin-right: 20px;"></div>
              <span>Assign Control Numbers</span>
            </button>

          </mat-menu>
        </div>
      </mat-toolbar>
      <mat-card class="card-under-toolbar" style="overflow: hidden; display: flex; height: 100%;">
        <mat-card-content class="mat-elevation-z2"
          style="overflow: hidden; flex: auto; display: flex; flex-direction: column;">
          <div style="overflow: auto; height: 100%;">
            <table mat-table [trackBy]="trackByFn" *ngIf="dataSource$ | async as dataSource" [dataSource]="dataSource"
              matSort (matSortChange)="sort($event)" class="table-width lex-dense neg _5" style="width: 100%;">
              <ng-container matColumnDef="selecto-checko" style="padding: 0 24px">
                <th mat-header-cell *matHeaderCellDef>
                  <div class="form-control-wrapper" style="padding-right: 24px; padding-left: 24px;">
                    <mat-checkbox
                      [indeterminate]="selectedUploadIds.length > 0 && selectedUploadIds.length < dataSource.data.length"
                      [checked]="selectedUploadIds.length === dataSource.data.length"
                      (change)="selectAll($event.checked)"></mat-checkbox>
                  </div>
                </th>
                <td mat-cell *matCellDef="let element">
                  <div class="form-control-wrapper" style="padding-left: 24px; padding-right: 24px;">
                    <mat-checkbox (change)="toggleSelected(element.id)"
                      [ngModel]="isSelected(element.id)"></mat-checkbox>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="title">
                <th mat-header-cell *matHeaderCellDef style="width: 10%;" mat-sort-header="batchTitle">Title</th>
                <td mat-cell *matCellDef="let element" [routerLink]="['/', 'review', 'browse']"
                  [queryParams]="{UploadBatchId: element.id}" style="cursor: pointer;" [matTooltip]="element.title">
                  <div class="cell-content">{{ element.title }}</div>
                </td>
              </ng-container>
              <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef style="width: 10%;" mat-sort-header="uploadBatchDate">Date</th>
                <td mat-cell *matCellDef="let element">{{ element.uploadDate | date: 'medium'}}</td>
              </ng-container>
              <ng-container matColumnDef="utcOffset">
                <th mat-header-cell *matHeaderCellDef style="width: 5%;" mat-sort-header="utcOffset">Utc Offset</th>
                <td mat-cell *matCellDef="let element">{{ element.utcOffset }}</td>
              </ng-container>
              <ng-container matColumnDef="comments">
                <th mat-header-cell *matHeaderCellDef style="width: 10%" mat-sort-header="batchComments">Comments</th>
                <td mat-cell *matCellDef="let element" [matTooltip]="element.comments">
                  <div class="cell-content">{{ element.comments }}</div>
                </td>
              </ng-container>
              <ng-container matColumnDef="username">
                <th mat-header-cell *matHeaderCellDef style="width: 15%;" mat-sort-header="user/userName">Username</th>
                <td mat-cell *matCellDef="let element">{{ element.username }}</td>
              </ng-container>
              <ng-container matColumnDef="custodian">
                <th mat-header-cell *matHeaderCellDef style="width: 15%;" mat-sort-header="custodian/name">Custodian
                </th>
                <td mat-cell *matCellDef="let element">{{ element.custodianName }}</td>
              </ng-container>
              <ng-container matColumnDef="source">
                <th mat-header-cell *matHeaderCellDef style="width: 15%;" mat-sort-header="docSource">Source</th>
                <td mat-cell *matCellDef="let element">{{ element.docSource }}</td>
              </ng-container>
              <ng-container matColumnDef="typeId">
                <th mat-header-cell *matHeaderCellDef style="width: 9%;" mat-sort-header="typeId">Upload Type</th>
                <td mat-cell *matCellDef="let element">{{ UploadBatchTypeLookup[element.typeId] }}</td>
              </ng-container>
              <ng-container matColumnDef="validationStatus">
                <th mat-header-cell *matHeaderCellDef style="width: 11%; padding-right: 0;"
                  mat-sort-header="validationStatus">Validation Status</th>
                <td mat-cell *matCellDef="let element">
                  <span *ngIf="element.validationStatus === validationStatus.NotRun">
                    <button mat-button color="primary" aria-label="QueueValidationStep"
                      [disabled]="!userConfigsService.inRoles(Role.EditFeatureSet)"
                      (click)="scheduleJobBatchValidation([element.id])"
                      id="queue-upload-batch-validation-{{element.id}}">
                      <div class="fal fa-exclamation-circle" style="font-size: 18px; margin-right: 10px;"></div>
                      Validate
                    </button>
                  </span>
                  <span *ngIf="element.validationStatus !== validationStatus.NotRun">
                    <button mat-button [routerLink]="element.validationReportRoute"
                      id="view-upload-batch-validation-report-{{element.id}}">
                      <span *ngIf="element.validationStatus === validationStatus.Passed">
                        <div class="fal fa-check-circle" style="font-size: 18px; margin-right: 10px;">
                        </div> Passed
                      </span>
                      <span *ngIf="element.validationStatus === validationStatus.Warnings">
                        <div class="fal fa-exclamation-triangle"
                          style="font-size: 18px; margin-right: 10px; color: #FBC02D;"></div>
                        Warnings
                      </span>
                      <span *ngIf="element.validationStatus === validationStatus.Failed">
                        <div class="fal fa-times-circle" style="font-size: 18px; margin-right: 10px;"></div>
                        Failed
                      </span>
                      <span *ngIf="element.validationStatus === validationStatus.Info">
                        <div class="fal fa-exclamation-circle" style="font-size: 18px; margin-right: 10px;"></div>
                        Info
                      </span>
                      <span *ngIf="element.validationStatus === validationStatus.Validating">
                        <div class="fal fa-traffic-cone" style="font-size: 18px; margin-right: 10px;"></div>
                        Validating
                      </span>
                      <span *ngIf="element.validationStatus === validationStatus.Unsupported">
                        <div class="fal fa-file-excel" style="font-size: 18px; margin-right: 10px;"></div>
                        Unsupported
                      </span>
                      <span *ngIf="element.validationStatus === validationStatus.Error">
                        <div class="fal fa-times-circle" style="font-size: 18px; margin-right: 10px;"></div>
                        Error
                      </span>
                    </button>
                  </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="manage-actions">
                <th mat-header-cell *matHeaderCellDef style="width: 3%"></th>
                <td mat-cell *matCellDef="let item">
                  <button id="row-menu-{{item.id}}" mat-icon-button [matMenuTriggerFor]="menu"
                    style="margin: 0 30px 0 0;">
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <button mat-menu-item routerLink="/analytics/case-assessment">
                      <div class="fal fa-magnifying-glass-chart" style="font-size: 18px; margin-right: 20px;"></div>
                      <span>View Upload Reports</span>
                    </button>
                    <button mat-menu-item [routerLink]="['/', 'case', 'uploads', item.id]" id="edit-upload-{{item.id}}">
                      <div class="fal fa-pencil-square" style="font-size: 18px; margin-right: 20px;"></div>
                      <span>Edit Upload</span>
                    </button>
                    <button mat-menu-item *ngIf="shouldShowDatOption(item)"
                      [routerLink]="['/', 'case', 'dat-metadata-mapping', item.id]" id="apply-dat-{{item.id}}">
                      <div class="fal fa-file-import" style="font-size: 18px; margin-right: 20px;"></div>
                      <span>View Dat file mapping page</span>
                    </button>
                  </mat-menu>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
              <tr mat-row *matRowDef="let row; columns:columnsToDisplay"></tr>
            </table>
          </div>
          <div class="paging-container">
            <mat-paginator [pageSize]="25" [pageSizeOptions]="[25, 50, 100, 200]" [length]="totalEntries$ | async"
              (page)="movePage($event)" showFirstLastButtons #paginator></mat-paginator>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
